{
  "page": {
    "title": "Theo dõi vận đơn",
    "subtitle": "Theo dõi vận đơn đang chạy, xử lý RTS, và thử lại các lỗi tracking.",
    "tabsAria": "Các tab vận đơn",
    "panelAria": "Bảng {{tab}}",
    "loadFailed": "Không tải được danh sách shipments."
  },
  "common": {
    "networkError": "Lỗi mạng - kiểm tra kết nối",
    "loading": "Đang tải shipments..."
  },
  "tabLabels": {
    "in_transit": "Trên đường",
    "rts": "RTS Queue",
    "errors": "Tracking Lỗi"
  },
  "filters": {
    "ariaLabel": "Bộ lọc vận đơn",
    "carrier": "Đơn vị vận chuyển",
    "carrierAll": "— Tất cả —",
    "search": "Tìm (đơn # hoặc tracking #)",
    "searchPlaceholder": "PWO… hoặc số tracking",
    "vendorId": "Vendor ID",
    "dateFrom": "Từ ngày",
    "dateTo": "Đến ngày",
    "apply": "Áp dụng",
    "reset": "Xóa bộ lọc",
    "reload": "Tải lại",
    "validation": {
      "invalidDate": "Vui lòng nhập ngày và giờ hợp lệ.",
      "dateRange": "Ngày bắt đầu phải trước hoặc bằng ngày kết thúc."
    }
  },
  "inTransit": {
    "loading": "Đang tải shipments...",
    "empty": "Không có shipment đang vận chuyển.",
    "columns": {
      "tracking": "Tracking #",
      "carrier": "Đơn vị vận chuyển",
      "status": "Trạng thái",
      "vendor": "Vendor",
      "eta": "ETA",
      "firstScan": "Quét đầu tiên",
      "delivered": "Đã giao",
      "updated": "Cập nhật",
      "order": "Đơn",
      "actions": "Hành động"
    }
  },
  "status": {
    "stale": "Ngừng cập nhật"
  },
  "refresh": {
    "aria": "Làm mới tracking",
    "loading": "Đang làm mới tracking…",
    "success": "Đã làm mới tracking",
    "terminalTooltip": "Đã giao xong — không cần làm mới",
    "errors": {
      "noPerm": "Bạn không có quyền làm mới tracking",
      "notFound": "Không tìm thấy kiện hàng",
      "quotaExceeded": "Đã đạt giới hạn làm mới tracking — thử lại sau",
      "carrierDown": "Đơn vị vận chuyển tạm thời không khả dụng — thử lại sau",
      "generic": "Không thể làm mới tracking"
    }
  },
  "rtsQueue": {
    "loading": "Đang tải RTS queue...",
    "empty": "Không có đơn nào trong RTS queue.",
    "columns": {
      "order": "Đơn",
      "merchant": "Merchant",
      "vendor": "Vendor",
      "returnReason": "Lý do trả",
      "returnedAt": "Ngày trả",
      "actions": "Hành động"
    },
    "actions": {
      "shipAgain": "Ship lại",
      "refund": "Hoàn tiền",
      "openTicket": "Mở ticket",
      "unavailable": "Chưa hỗ trợ — hệ thống chưa tự xử lý hoàn tiền và gửi lại hàng. Vui lòng xử lý đơn hoàn này thủ công."
    }
  },
  "trackingErrors": {
    "loading": "Đang tải tracking errors...",
    "empty": "Không có đơn nào bị lỗi tracking.",
    "columns": {
      "order": "Đơn",
      "tracking": "Tracking #",
      "carrier": "Đơn vị vận chuyển",
      "lastFetch": "Lần fetch cuối",
      "failures": "Số lần lỗi",
      "error": "Lỗi",
      "actions": "Hành động"
    },
    "retry": "Thử lại",
    "retrying": "Đang thử...",
    "toast": {
      "notAccepted": "Yêu cầu thử lại không được chấp nhận",
      "queuedTitle": "Đã đưa vào hàng đợi thử lại",
      "queuedDesc": "Đơn {{orderNumber}} → đơn vị vận chuyển sẽ thử lại."
    }
  },
  "shipAgain": {
    "dialogAria": "Ship lại tới địa chỉ mới",
    "title": "Ship lại — đơn {{orderNumber}}",
    "description": "Nhập địa chỉ mới. Phí ship được trừ vào ví merchant. Vendor sẽ tạo fulfillment mới.",
    "fields": {
      "fullName": "Họ tên người nhận *",
      "line1": "Địa chỉ dòng 1 *",
      "line2": "Địa chỉ dòng 2",
      "city": "Thành phố *",
      "state": "Bang / Tỉnh",
      "postalCode": "Mã bưu chính *",
      "country": "Quốc gia (ISO-2) *",
      "phone": "Số điện thoại",
      "note": "Ghi chú"
    },
    "cancel": "Hủy",
    "submit": "Ship lại",
    "submitting": "Đang gửi...",
    "toast": {
      "notAccepted": "Yêu cầu ship lại không được chấp nhận",
      "queuedTitle": "Đã đưa ship lại vào hàng đợi",
      "queuedDesc": "Đơn {{orderNumber}} → fulfillment mới đã vào hàng đợi."
    }
  },
  "refund": {
    "dialogAria": "Hoàn tiền đơn hàng",
    "title": "Hoàn tiền — đơn {{orderNumber}}",
    "description": "Hoàn tiền vào ví merchant. Có thể chọn bồi thường vendor từ ví platform.",
    "fields": {
      "amount": "Số tiền hoàn (USD) *",
      "reason": "Lý do *",
      "justification": "Giải trình * (tối thiểu 10 ký tự)",
      "vendorComp": "Bồi thường vendor (USD, không bắt buộc)"
    },
    "reasons": {
      "SHIPPING_LOST": "Lạc hàng / mất hàng",
      "CUSTOMER_DISSATISFACTION": "Khách không hài lòng",
      "QUALITY_DEFECT": "Lỗi chất lượng",
      "WRONG_ADDRESS": "Sai địa chỉ",
      "CARRIER_RETURN": "Đơn vị vận chuyển trả về",
      "OTHER": "Khác"
    },
    "validation": {
      "amountInvalid": "Số tiền phải lớn hơn 0.",
      "justificationTooShort": "Giải trình phải có ít nhất 10 ký tự."
    },
    "cancel": "Hủy",
    "submit": "Hoàn tiền",
    "submitting": "Đang gửi...",
    "toast": {
      "notAccepted": "Yêu cầu hoàn tiền không được chấp nhận",
      "queuedTitle": "Đã đưa hoàn tiền vào hàng đợi",
      "queuedDesc": "Đơn {{orderNumber}} → hoàn {{amount}}."
    }
  },
  "openTicket": {
    "dialogAria": "Mở ticket hỗ trợ",
    "title": "Mở ticket — đơn {{orderNumber}}",
    "description": "Tạo ticket hỗ trợ liên kết tới đơn này. Merchant sẽ được thông báo.",
    "fields": {
      "subject": "Tiêu đề (không bắt buộc)",
      "body": "Nội dung *",
      "priority": "Ưu tiên *",
      "category": "Phân loại *"
    },
    "priorities": {
      "LOW": "Thấp",
      "NORMAL": "Bình thường",
      "HIGH": "Cao",
      "URGENT": "Khẩn cấp"
    },
    "validation": {
      "bodyRequired": "Nội dung ticket là bắt buộc."
    },
    "cancel": "Hủy",
    "submit": "Mở ticket",
    "submitting": "Đang gửi...",
    "toast": {
      "notAccepted": "Yêu cầu mở ticket không được chấp nhận",
      "queuedTitle": "Đã đưa ticket vào hàng đợi",
      "queuedDesc": "Đơn {{orderNumber}} → ticket ưu tiên {{priority}}."
    }
  },
  "_vgBinding": "vg-binding: P4.11.D-29,P4.11.D-30,P4.11.D-31,P4.11.D-32 — i18n keys for In Transit First Scan/Delivered/Actions columns + stale badge label (status.stale, enum VALUE stays English) across en/vi/fr [task-18]"
}
